import { render, staticRenderFns } from "./ConfigContact.vue?vue&type=template&id=41e0e8ce&scoped=true"
import script from "./ConfigContact.vue?vue&type=script&lang=js"
export * from "./ConfigContact.vue?vue&type=script&lang=js"
import style0 from "./ConfigContact.vue?vue&type=style&index=0&id=41e0e8ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e0e8ce",
  null
  
)

export default component.exports